import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import { Grid } from '@mui/material';

import AlarmManagementPieChartLegend from './PieChartLegend';

const PieChart: React.FC = () => {
  const chartRef = useRef<HTMLDivElement>(null);

  const getPieChartColors = () => {
    const cssVarNames = [
      '--color-light',
      '--color-light-shade',
      '--color-light-shade-secondary: ',
      '--color-dark',
      '--color-contrast',
      '--color-accent-shade-secondary',
      '--color-accent-shade',
      '--color-secondary-accent',
      '--color-primary-accent',
      '--color-secondary-accent-shade',
    ];

    const pieChartItemColors = cssVarNames.map((el) =>
      getComputedStyle(document.documentElement).getPropertyValue(el)
    );

    return pieChartItemColors;
  };

  const getDummyData = () => {
    const pieChartItemColors = getPieChartColors();

    const dummyData = [
      {
        value: 239,
        name: 'Type 1',
        percentage: 80,
        color: pieChartItemColors[0],
        progress: 'up',
      },
      {
        value: 211,
        name: 'Type 2',
        percentage: 20,
        color: pieChartItemColors[1],
        progress: 'down',
      },
      {
        value: 179,
        name: 'Type 3',
        percentage: 20,
        color: pieChartItemColors[2],
        progress: 'down',
      },
      {
        value: 120,
        name: 'Type 4',
        percentage: 25,
        color: pieChartItemColors[3],
        progress: 'up',
      },
      {
        value: 111,
        name: 'Type 5',
        percentage: 37,
        color: pieChartItemColors[4],
        progress: 'up',
      },
      {
        value: 102,
        name: 'Type 6',
        percentage: 20,
        color: pieChartItemColors[5],
        progress: 'down',
      },
      {
        value: 80,
        name: 'Type 7',
        percentage: 20,
        color: pieChartItemColors[6],
        progress: 'down',
      },
      {
        value: 69,
        name: 'Type 8',
        percentage: 20,
        color: pieChartItemColors[7],
        progress: 'down',
      },
      {
        value: 45,
        name: 'Type 9',
        percentage: 20,
        color: pieChartItemColors[8],
        progress: 'down',
      },
    ];
    return dummyData;
  };

  useEffect(() => {
    if (chartRef.current) {
      const chartInstance = echarts.init(chartRef.current);

      const dummyData = getDummyData();

      const totalAlarms = dummyData.reduce((a, b) => a + b.value, 0);
      const options: echarts.EChartOption<any> = {
        title: {
          text: `Total \n\n${totalAlarms} Alarms`,
          left: 'center',
          top: 'center',
        },
        series: [
          {
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              borderRadius: 16,
              borderColor: '#fff',
              borderWidth: 4,
            },
            data: dummyData.map((el) => ({
              value: el.value,
              name: el.name,
              itemStyle: { color: el.color },
            })),
          },
        ],
      };

      chartInstance.setOption(options);

      // Cleanup on component unmount
      return () => {
        chartInstance.dispose();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="pie-chart-container">
      <div className="chart-title">Top 10 firing instances</div>
      <Grid container>
        <Grid item xs={6}>
          <div ref={chartRef} style={{ width: '100%', height: '400px' }} />
        </Grid>
        <Grid item xs={6}>
          <AlarmManagementPieChartLegend data={getDummyData()} />
        </Grid>
      </Grid>
    </div>
  );
};

export default PieChart;
